import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from 'swiper';

import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.css';

import motivo1Img from '../style/images/Motivo1.png';
import motivo2Img from '../style/images/Motivo2.png';
import motivo3Img from '../style/images/Motivo3.png';
import motivo4Img from '../style/images/Motivo4.png';
import motivo5Img from '../style/images/Motivo5.png';

SwiperCore.use([Navigation, Pagination]);

export default function CardSwiper() {
  return (
    <section className="section-lines">
      <div className="container text-center">
        <h1 className="titulo">Esse curso combina comigo? Bora descobrir.</h1>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
        >
          <SwiperSlide>
            <img className="motivoImg" src={motivo1Img} alt="Motivo 1" />
            <p className="p-md margin-bottom">Quer entender seus sentimentos e emoções?</p>
          </SwiperSlide>
          <SwiperSlide>
            <img className="motivoImg" src={motivo2Img} alt="Motivo 2" />
            <p className="p-md margin-bottom">Sente que sua juventude tem um propósito maior?</p>
          </SwiperSlide>
          <SwiperSlide>
            <img className="motivoImg" src={motivo3Img} alt="Motivo 3" />
            <p className="p-md margin-bottom">Está buscando se conhecer melhor?</p>
          </SwiperSlide>
          <SwiperSlide>
            <img className="motivoImg" src={motivo4Img} alt="Motivo 4" />
            <p className="p-md margin-bottom">Quer aprender a cuidar de si mesmo(a) com mais amor e responsabilidade?</p>
          </SwiperSlide>
          <SwiperSlide>
            <img className="motivoImg" src={motivo5Img} alt="Motivo 5" />
            <p className="p-md margin-bottom">Acredita que pode se transformar e transformar o mundo? Então, vem!</p>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
}
